import styled from 'styled-components';

export const PaginationContainer = styled.div`
  align-items: center;
  border-top: 1px solid #E9EAEB;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 24px;
`;